import React, { useState } from "react";
import Axios from "axios";
import { useParams } from "react-router-dom";
import HtmlReactParser from "html-react-parser";
import CommentSection from "./CommentSection";

const Post = () => {
  const params = useParams();
  const [userName, setUserName] = useState("");
  const [postTitle, setPostTitle] = useState("");
  const [post, setPost] = useState("");
  Axios.get(
    "https://fitness-junction-bots.onrender.com/api/getpost/" + params.postId
  )
    .then((data) => {
      setUserName(data.data.postData[0].userName);
      setPostTitle(data.data.postData[0].postTitle);
      setPost(data.data.postData[0].post);
    })
    .catch((error) => console.log(error));
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="card singlepostcard">
            <div className="card-body">
              <h2 className="card-title fw-semibold">{postTitle}</h2>
              <h6 className="card-subtitle mb-2 text-muted">{userName}</h6>
              <div className="card-text">{HtmlReactParser(post)}</div>
            </div>
            <div className="card-footer">
              <CommentSection postId={params.postId} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Post;
